/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown>, total: NonNullable<unknown>, breakdown: NonNullable<unknown> }} Chartcolumntext2Inputs */

const en_chartcolumntext2 = /** @type {(inputs: Chartcolumntext2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}: ${i?.total} in total. ${i?.breakdown}`)
};

const de_chartcolumntext2 = /** @type {(inputs: Chartcolumntext2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}: insgesamt ${i?.total}. ${i?.breakdown}`)
};

/**
* | output |
* | --- |
* | "{date}: {total} in total. {breakdown}" |
*
* @param {Chartcolumntext2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const chartcolumntext2 = /** @type {((inputs: Chartcolumntext2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chartcolumntext2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chartcolumntext2(inputs)
	return de_chartcolumntext2(inputs)
});
export { chartcolumntext2 as "chartColumnText" }